import React, { useContext } from "react"
import { NotificationContext } from "./notification-context.js"

/**
 * @hook useNotification
 * @description Hook para consumir o NotificationContext
 * @returns {import("./notification-context.js").NotificationContextValue}
 */
export function useNotification() {
    const context = useContext(NotificationContext)
    if (context === undefined) {
        throw new Error("useNotification must be used within a NotificationContext")
    }
    return context
}
